export const notesPermissionsConst = {
  view: {
    value: "view_note",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu notatki!",
  },
  add: {
    value: "add_note",
    errorMsg: "Użytkownik nie ma uprawnień do dodania notatki!",
  },
  update: {
    value: "change_note",
    errorMsg: "Użytkownik nie ma uprawnień do edycji notatki!",
  },
  delete: {
    value: "delete_note",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania notatki!",
  },
};
